import * as ww from '@wecom/jssdk';
import {
  CreateOpenDataFrameParams,
  initOpenData,
  OpenDataFrameInstance,
  register,
  RegisterOptions,
  SignatureData,
} from '@wecom/jssdk';
import { useUser } from '@/store/pinia/userStore';
import { apiWecomJSSDK } from '@/request/apiWecomJSSDK';
import { api } from '@/request/api';
import { RouteName } from '@/router/RouteName';
import { useRouter } from 'vue-router';

export type TicketDTO = SignatureData;

// register({
//   corpId:"",
//   jsApiList:[],
//   getConfigSignature
// })
async function getConfigSignature(url: string): Promise<SignatureData> {
  const res = await apiWecomJSSDK.configSignature(url);
  return {
    timestamp: res.data.timestamp,
    signature: res.data.signature,
    nonceStr: res.data.nonceStr,
  };
}
async function getAgentConfigSignature(url: string): Promise<SignatureData> {
  const res = await apiWecomJSSDK.agentConfigSignature(url);
  return {
    timestamp: res.data.timestamp,
    signature: res.data.signature,
    nonceStr: res.data.nonceStr,
  };
}
let factory: {
  /**
   * 创建 open-data frame 组件
   */
  createOpenDataFrame: <
    TData extends Record<string, any>,
    TMethods extends Record<string, (...args: unknown[]) => unknown>,
  >(
    options: CreateOpenDataFrameParams<TData, TMethods>,
  ) => OpenDataFrameInstance<TData, TMethods>;
} | null = null;
export const MyWWSDK = {
  registry() {
    const store = useUser();
    const user = store.$state.user;
    if (user) {
      const params: RegisterOptions = {
        corpId: user.loginCorpid,
        getConfigSignature: getConfigSignature,
        getAgentConfigSignature: getAgentConfigSignature,
        agentId: user.agentId,
        jsApiList: [
          'getContext',
          'getCurExternalContact',
          'getCurExternalChat',
          'sendChatMessage',
          'openUserProfile',
          'selectExternalContact',
          'openEnterpriseChat',
          'openExistedChatWithMsg',
          'hideChatAttachmentMenu',
          'selectEnterpriseContact',
          'openUserProfile',
          'wwapp.invokeJsApiByCallInfo',
          'openAppManage',
        ],
        onConfigSuccess(data) {
          console.log('onConfigSuccess', data);
        },
        onConfigFail(data) {
          console.log('onConfigFail', data);
        },
        onConfigComplete(data) {
          console.log('onConfigComplete', data);
        },
        onAgentConfigSuccess(data) {
          console.log('onAgentConfigSuccess', data);
        },
        onAgentConfigFail(data) {
          console.log('onAgentConfigFail', data);
        },
        onAgentConfigComplete(data) {
          console.log('onAgentConfigComplete', data);
        },
      };
      register(params);
      if (user.isAuthCorp) {
        initOpenData({
          success(res) {
            console.log('initOpenData success', res);
          },
          fail(res) {
            console.error('initOpenData fail', res);
          },
        });
      }
    }
  },
  getWW() {
    return ww;
  },
  getOpenDataFrameFactory(): {
    /**
     * 创建 open-data frame 组件
     */
    createOpenDataFrame: <
      TData extends Record<string, any>,
      TMethods extends Record<string, (...args: unknown[]) => unknown>,
    >(
      options: CreateOpenDataFrameParams<TData, TMethods>,
    ) => OpenDataFrameInstance<TData, TMethods>;
  } {
    if (factory === null) {
      ww.initOpenData();
      factory = ww.createOpenDataFrameFactory();
    }
    return factory;
  },
};

export function onOpenMsgError(event: any) {
  console.log('open message error: ', event);
  const { errCode, errMsg } = event?.detail;
  if (
    errCode === 42006 ||
    errCode === 42003 ||
    errCode === 40029 ||
    errMsg === 'Missing open sid'
  ) {
    console.error('==================会话组件登录过期===============');
    const router = useRouter();
    api.logout().finally(() => {
      router.replace({
        name: RouteName.LOGIN,
      });
    });
  }
}
